import { render, staticRenderFns } from "./CompanyDormitory.vue?vue&type=template&id=ea230f7c"
import script from "./CompanyDormitory.vue?vue&type=script&lang=js"
export * from "./CompanyDormitory.vue?vue&type=script&lang=js"
import style0 from "./CompanyDormitory.vue?vue&type=style&index=0&id=ea230f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports